import {useState} from 'react';

import './TopItems.scss';
import TopItemsBeers from './TopItemsBeers/TopItemsBeers';
import TopItemsBreweries from './TopItemsBreweries/TopItemsBreweries';

const TopItems = () => {
  const [activeTab, setActiveTab] = useState<'beers' | 'breweries'>('beers');

  const tabs = {
    beers: <TopItemsBeers />,
    breweries: <TopItemsBreweries />,
  };

  return (
    <div className="top-items">
      <div className="top-items__header">
        <button
          type="button"
          title="Top 10 beers"
          onClick={() => setActiveTab('beers')}
          className={`manager-page__top-title top-items__first-title ${
            activeTab === 'beers' ? 'manager-page__top-title--active' : ''
          }`}
        >
          top 10 beers
        </button>
        <button
          type="button"
          title="Top 10 breweries"
          onClick={() => setActiveTab('breweries')}
          className={`manager-page__top-title ${activeTab === 'breweries' ? 'manager-page__top-title--active' : ''}`}
        >
          top 10 breweries
        </button>
      </div>
      <div className="top-items__content">{tabs[activeTab]}</div>
    </div>
  );
};

export default TopItems;
